import Vue from "vue"
import Vuex from "vuex"
// import Raven from "raven-js"

import * as userApi from "../../common/api/user"
import * as tuanApi from "../../common/api/tuan_proc"

import user from "../../common/store/modules/user"
import wzry from "../../common/store/modules/wzry"

Vue.use(Vuex)

let configs = window.__midasStaticConfig_wzry_tuan_config

export default new Vuex.Store({
  modules: {
    user,
    wzry
  },
  state: {
    pfSource: "mds_wechat_gmshop",
    tuanInfo: null,
    userTuanInfo: null,

    dialogConfig: {
      dialogContent: "",
      confirmText: "",
      onConfirm: null,
      cancelText: "",
      onCancel: null,
      targetClassName: "",
      hideClose: false
    },
    isLoading: false,
    loadingMsg: "",
    toastMsg: "",
    showShareDialog: false,

    subscribeStatus: null // 是否关注公众号
  },
  getters: {
    pfSource: state => state.pfSource,
    isInMSDK: state => state.userAgent.msdk,
    gameInfoConfigs: () => configs.GAME_INFO,
    tuanInfo: state => state.tuanInfo,
    userTuanInfo: state => state.userTuanInfo,
    subscribeStatus: state => state.subscribeStatus,
    // 最小成团人数
    minJoinTuanNum: () => {
      if (configs.GAME_INFO && configs.GAME_INFO.tuanConfig && configs.GAME_INFO.tuanConfig.minJoinTuanNum) {
        return configs.GAME_INFO.tuanConfig.minJoinTuanNum
      } else {
        return 0
      }
    },
    tuanProductConfig: () => {
      if (configs.GAME_INFO && configs.GAME_INFO.tuanProductConfig) {
        return configs.GAME_INFO && configs.GAME_INFO.tuanProductConfig
      } else {
        return {}
      }
    },
    activityProductConfig: () => {
      if (configs.GAME_INFO && configs.GAME_INFO.activityProductConfig) {
        return configs.GAME_INFO && configs.GAME_INFO.activityProductConfig
      } else {
        return {}
      }
    }
  },
  actions: {
    getGroupBuyings({ state, getters, commit }, tuanId) {
      let extend = {
        type: "bg",
        buy_type: "buytuan"
      }

      return tuanApi
        .tuanProc(
          {
            sandbox: state.user.sandbox,
            openid: state.user.openid,
            openkey: state.user.openkey,
            sessionId: state.user.sessionId,
            sessionType: state.user.sessionType,
            wxAppid2: state.user.wxAppid2,
            offerId: getters.offerId,
            action: "query_activity",
            drm_info: `tuan_group=${encodeURIComponent(getters.gameInfoConfigs.tuanConfig.activityNum)}&version=3.0${
              tuanId ? "&tuan_id=" + tuanId : ""
            }`
          },
          extend
        )
        .then(res => {
          if (tuanId) {
            commit("SET_USER_TUAN_INFO", res.tuan_info)
          } else {
            commit("SET_TUAN_INFO", res.tuan_info)
          }
        })
    },
    openGroupBuying({ state, getters }) {
      return tuanApi.tuanProc(
        {
          sandbox: state.user.sandbox,
          openid: state.user.openid,
          openkey: state.user.openkey,
          sessionId: state.user.sessionId,
          sessionType: state.user.sessionType,
          wxAppid2: state.user.wxAppid2,
          offerId: getters.offerId,
          action: "open_tuan",
          drm_info: `tuan_group=${encodeURIComponent(getters.gameInfoConfigs.tuanConfig.activityNum)}&version=3.0&delay_flag=1`
        },
        {
          type: "bg",
          buy_type: "buytuan"
        }
      )
    },
    getMyGroup({ state, getters }) {
      return tuanApi.tuanProc(
        {
          sandbox: state.user.sandbox,
          openid: state.user.openid,
          openkey: state.user.openkey,
          sessionId: state.user.sessionId,
          sessionType: state.user.sessionType,
          wxAppid2: state.user.wxAppid2,
          offerId: getters.offerId,
          action: "query_user_tuan",
          drm_info: `tuan_group=${encodeURIComponent(getters.gameInfoConfigs.tuanConfig.activityNum)}&version=3.0`
        },
        {
          type: "bg",
          buy_type: "buytuan"
        }
      )
    },
    msdkShareTo({ dispatch, state, getters }, { selected, tuanId }) {
      let pf = "__mds_game_tuanshare"
      let shareParams = {
        desc: getters.gameInfoConfigs.shareInfo.detail.desc,
        title: getters.gameInfoConfigs.shareInfo.detail.title,
        url: `${location.protocol}//${location.host}${configs.GAME_INFO.sharePathName}?pf=${pf}${
          state.user.sandbox ? "&sandbox=" + state.user.sandbox : ""
        }&_wv=49153#/group-detail/${tuanId}?a=1`,
        imgData: getters.gameInfoConfigs.shareInfo.detail.ingame_base64_icon
      }

      if (selected === "weixin" || selected === "pengy") {
        shareParams.MsdkMethod = "WGSendToWeiXinWithUrl"
        shareParams.scene = selected === "weixin" ? "0" : "1"
        shareParams.mediaTagName = "MSG_INVITE"
        if (selected == "pengy") {
          dispatch("reportUserAction", {
            iformat: configs.REPORT.CLICK.INGAME_SHARE_TIMELINE,
            resultInfo: `tuan_id=${tuanId}`
          })
        }
        if (selected == "weixin") {
          dispatch("reportUserAction", {
            iformat: configs.REPORT.CLICK.INGAME_SHARE_WECHAT,
            resultInfo: `tuan_id=${tuanId}`
          })
        }
      } else {
        if (selected == "qzone") {
          shareParams.scene = 1
          dispatch("reportUserAction", {
            iformat: configs.REPORT.CLICK.INGAME_SHARE_QZONE,
            resultInfo: `tuan_id=${tuanId}`
          })
        }
        if (selected == "qq") {
          shareParams.scene = 2
          dispatch("reportUserAction", {
            iformat: configs.REPORT.CLICK.INGAME_SHARE_QQ,
            resultInfo: `tuan_id=${tuanId}`
          })
        }
        shareParams.MsdkMethod = "WGSendToQQ"
      }
      setTimeout(() => {
        if (window.msdkShare) {
          window.msdkShare(JSON.stringify(shareParams))
        }
      }, 100)
    },
    setOnShareHandler({ dispatch, state, getters }, tuanId) {
      let params = {
        wxAppid2: state.wxAppid2,
        img: getters.gameInfoConfigs.shareInfo.index.icon
      }
      if (tuanId) {
        // 分享小团
        params.title = getters.gameInfoConfigs.shareInfo.detail.title
        params.desc = getters.gameInfoConfigs.shareInfo.detail.desc
      } else {
        // 分享大团
        params.title = getters.gameInfoConfigs.shareInfo.index.title
        params.desc = getters.gameInfoConfigs.shareInfo.index.desc
      }

      if (getters.userAgent.QQ) {
        params.pf = "__mds_qqtuan_share"
        params.reportCallback = res => {
          if (res.retCode == 0) {
            dispatch("reportUserAction", {
              iformat: configs.REPORT.CLICK.SHARE_OUTER_QQ_SUCCESS
            })
          } else if (res.retCode == 1) {
            dispatch("reportUserAction", {
              iformat: configs.REPORT.CLICK.SHARE_OUTER_QQ_FAIL
            })
          }
          dispatch("reportUserAction", {
            iformat: configs.REPORT.CLICK.SHARE_OUTER_QQ,
            resultInfo: `tuan_id=${state.tuanId || ""}`
          })
        }
        userApi.setOnMqqShareHandler(params)
      } else if (getters.userAgent.weixin) {
        params.pf = "__mds_wxtuan_share"
        params.reportCallback = () => {
          dispatch("reportUserAction", {
            iformat: configs.REPORT.CLICK.SHARE_OUTER_WEIXIN,
            resultInfo: `tuan_id=${state.tuanId || ""}`
          })
        }
        userApi.setOnWechatShareHandler(params)
      }
    },
    setLoadingStart({ commit }, loadingMsg) {
      commit("SET_LOADING_STATUS", true)
      if (loadingMsg) commit("SET_LOADING_MSG", loadingMsg)
    },
    setLoadingEnd({ commit }) {
      commit("SET_LOADING_STATUS", false)
      commit("SET_LOADING_MSG", "")
    },
    setToastMsg({ commit }, toastMsg) {
      commit("SET_TOAST_MSG", toastMsg)
      setTimeout(() => {
        commit("SET_TOAST_MSG", "")
      }, 2000)
    },
    setShareDialogStatus({ commit, dispatch }, dialogStatus) {
      commit("SET_SHARE_DIALOG_STATUS", dialogStatus)

      dispatch("reportUserAction", {
        iformat: configs.REPORT.CLICK.INVITE_FRIENDS_JOIN
      })
    },
    openDialog({ state, commit }, dialogConfig) {
      // 如果当前有打开的dialog，这里直接return
      if (dialogConfig && state.dialogConfig && state.dialogConfig.isShown) return

      if (dialogConfig) {
        commit("SET_DIALOG_CONFIG", { isShown: true, ...dialogConfig })
      } else {
        commit("SET_DIALOG_CONFIG", { isShown: false })
      }
    },
    closePageLoading() {
      let pageLoadingDom = document.querySelector("#page_loading")
      if (pageLoadingDom && pageLoadingDom.style) {
        document.querySelector("#page_loading").style.display = "none"
      }
    },

    getSubscribeStatus({ state, getters, commit }) {
      // 可以通过配置来限制QQ/WX是否请求
      if (configs.GAME_INFO.getSubscribeRequest && configs.GAME_INFO.getSubscribeRequest.indexOf(getters.accountType) > -1) {
        let params = {
          sandbox: state.user.sandbox,
          offerId: getters.offerId
        }
        let extendParams = {
          ...getters.loginState,
          wx_direct_pay: 0,
          wx_publice_pay: 0,
          action: "query_follow"
        }
        return userApi
          .mobileSubscribe(params, extendParams)
          .then(res => {
            if (res.info && res.info.is_followed) {
              commit("SET_SUBSCRIBE_STATUS", true)
            } else {
              commit("SET_SUBSCRIBE_STATUS", false)
            }
          })
          .catch(error => {
            // 旁路，不处理
            console.log(error)
          })
      }
    },

    goToStorePage({ getters, dispatch }) {
      let link = configs.GAME_INFO.storeZoneLink
      if (getters.userAgent.QQ || getters.userAgent.weixin) {
        // dispatch("reportAndJump", {
        //   iformat: configs.REPORT.CLICK.GO_STORE,
        //   target: link,
        //   resultInfo: {}
        // })
        location.href = configs.GAME_INFO.storeZoneLink
      } else {
        if (getters.accountType == "wechat") {
          dispatch("jumpToWechatLink", link)
        } else {
          location.href = `mqqapi://forward/url?src_type=web&version=1&url_prefix=${btoa(link)}`
        }
      }
    },

    // 打开QQ或微信，并跳转到活动页
    goToActivityPage({ dispatch }, accountType) {
      let link = configs.GAME_INFO.activityLink
      if (accountType == "wechat") {
        dispatch("jumpToWechatLink", link)
      } else {
        dispatch("setLoadingStart")
        setTimeout(() => {
          dispatch("setLoadingEnd")
        }, 2000)
        userApi.jumpToMqq(link)
      }
    },

    jumpToWechatLink({ state, getters, dispatch }, link) {
      dispatch("setLoadingStart")
      userApi
        .getOpenlink(
          {
            offerId: getters.offerId,
            sandbox: state.user.sandbox
          },
          {
            url: link
          }
        )
        .then(res => {
          if (res.info && res.info.openlink) {
            location.href = res.info.openlink
          } else {
            dispatch("setToastMsg", "跳转失败，请稍后再试")
          }
          setTimeout(() => {
            dispatch("setLoadingEnd")
          }, 1000)
        })
        .catch(() => {
          dispatch("setLoadingEnd")
          dispatch("setToastMsg", "跳转失败，请稍后再试")
        })
    }
  },
  mutations: {
    ["SET_TUAN_INFO"](state, tuanInfo) {
      state.tuanInfo = tuanInfo
    },
    ["SET_USER_TUAN_INFO"](state, userTuanInfo) {
      state.userTuanInfo = userTuanInfo
    },
    ["SET_DIALOG_CONFIG"](state, dialogConfig) {
      state.dialogConfig = dialogConfig
    },
    ["SET_LOADING_STATUS"](state, isLoading) {
      state.isLoading = isLoading
    },
    ["SET_LOADING_MSG"](state, loadingMsg) {
      state.loadingMsg = loadingMsg
    },
    ["SET_TOAST_MSG"](state, toastMsg) {
      state.toastMsg = toastMsg
    },
    ["SET_SHARE_DIALOG_STATUS"](state, showShareDialog) {
      state.showShareDialog = showShareDialog
    },
    ["SET_SUBSCRIBE_STATUS"](state, subscribeStatus) {
      state.subscribeStatus = subscribeStatus
    }
  },
  strict: process.env.NODE_ENV === "debug"
})
